export const TYPE = {
  PAGINATED: 'Paginated Report',
  REPORT: 'Report'
};
